const ranges = document.querySelectorAll("th[data-qty-range]");
const prices = document.querySelectorAll("td[data-qty-price]");
const quantityInput = document.getElementById("quantity");
const normalPrice = document.querySelector("p.price");
const tempNormalPriceHTML = normalPrice.innerHTML;
const tempNormalPrice = document.querySelector("p.price strong").innerHTML;
let qtyBreaks = [];

ranges.forEach((range, index) => {
  qtyBreaks[index] = {
    price: parseFloat(prices[index].dataset.qtyPrice).toFixed(2),
    range: ranges[index].dataset.qtyRange,
  };
});

quantityInput.addEventListener("change", (event) => { 
  const inputNum = parseInt(event.target.value);

  for (let index = 0; index < qtyBreaks.length; index++) {
    const [start, end] = qtyBreaks[index].range.split("-");
    if (
      (parseInt(start) <= inputNum  && inputNum <= parseInt(end)) ||
      (inputNum >= parseInt(start) && end === undefined )
    ) {
      normalPrice.innerHTML = `<strong class="sale-price">$${qtyBreaks[index].price}</strong> <strike class="normal-price">${tempNormalPrice}</strike></span>`;
      break;
    } else {
      normalPrice.innerHTML = tempNormalPriceHTML;
    }
  }

});



